"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityMatchPreviewDto = instanceOfOrientationOpportunityMatchPreviewDto;
exports.OrientationOpportunityMatchPreviewDtoFromJSON = OrientationOpportunityMatchPreviewDtoFromJSON;
exports.OrientationOpportunityMatchPreviewDtoFromJSONTyped = OrientationOpportunityMatchPreviewDtoFromJSONTyped;
exports.OrientationOpportunityMatchPreviewDtoToJSON = OrientationOpportunityMatchPreviewDtoToJSON;
exports.OrientationOpportunityMatchPreviewDtoToJSONTyped = OrientationOpportunityMatchPreviewDtoToJSONTyped;
const ProfileWithAddresses_1 = require("./ProfileWithAddresses");
/**
 * Check if a given object implements the OrientationOpportunityMatchPreviewDto interface.
 */
function instanceOfOrientationOpportunityMatchPreviewDto(value) {
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityMatchPreviewDtoFromJSON(json) {
    return OrientationOpportunityMatchPreviewDtoFromJSONTyped(json, false);
}
function OrientationOpportunityMatchPreviewDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfile': (0, ProfileWithAddresses_1.ProfileWithAddressesFromJSON)(json['nurseProfile']),
        'isQualifiedForStipend': json['isQualifiedForStipend'] == null ? undefined : json['isQualifiedForStipend'],
        'distanceMiles': json['distanceMiles'] == null ? undefined : json['distanceMiles'],
    };
}
function OrientationOpportunityMatchPreviewDtoToJSON(json) {
    return OrientationOpportunityMatchPreviewDtoToJSONTyped(json, false);
}
function OrientationOpportunityMatchPreviewDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfile': (0, ProfileWithAddresses_1.ProfileWithAddressesToJSON)(value['nurseProfile']),
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'distanceMiles': value['distanceMiles'],
    };
}
//# sourceMappingURL=OrientationOpportunityMatchPreviewDto.js.map